import React from 'react';
import PatientFormTemplate from './components/PatientFormTemplate';

export default function PatientMedicalHistoryForm() {
    return (
        <PatientFormTemplate formTitle="Your Health" />
    );
}